import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['days', 'dayText', 'hours', 'minutes', 'seconds', 'notifyButton', 'notifyForm']
  static values = { targetTime: String }

  connect() {
    this.updateCountdown()
    this.interval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    const now = new Date().getTime()
    const target = new Date(this.targetTimeValue).getTime()
    const distance = target - now

    if (distance < 0) {
      // Countdown finished - reload the page or redirect
      window.location.reload()
      return
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

    // Update the display with leading zeros
    if (this.hasDaysTarget) {
      this.daysTarget.textContent = String(days).padStart(2, '0')
    }
    if (this.hasHoursTarget) {
      this.hoursTarget.textContent = String(hours).padStart(2, '0')
    }
    if (this.hasMinutesTarget) {
      this.minutesTarget.textContent = String(minutes).padStart(2, '0')
    }
    if (this.hasSecondsTarget) {
      this.secondsTarget.textContent = String(seconds).padStart(2, '0')
    }

    if (this.hasDayTextTarget) {
      this.dayTextTarget.textContent = days === 1 ? 'day' : 'days'
    }
  }

  showNotifyForm() {
    this.notifyButtonTarget.classList.add('hidden')
    this.notifyFormTarget.classList.remove('hidden')
    // Focus on the email input
    this.notifyFormTarget.querySelector('input[type="email"]').focus()
  }

  hideNotifyForm() {
    this.notifyFormTarget.classList.add('hidden')
    this.notifyButtonTarget.classList.remove('hidden')
  }
}
